import { ACCESSIBLITY_WIZARD_APP_DEF_ID } from '@wix/a11y-wizard';
import { Duplexer } from '@wix/duplexer-js';

import type { Shell } from 'repluggable';

import type { A11yWizardDuplexerAPI } from '@wix/a11y-adapters/studio';
import type { A11yWizardDuplexerScopedState } from './store';
import {
  a11yWizardDuplexerActions,
  createA11yWizardDuplexerSelector,
} from './store';

const DUPLEXER_URL = 'duplexer.wix.com';

export const createA11yWizardDuplexerAPI = (
  shell: Shell,
): A11yWizardDuplexerAPI => {
  const store = shell.getStore<A11yWizardDuplexerScopedState>();
  const selectors = createA11yWizardDuplexerSelector(
    () => store.getState().a11yWizardDuplexerState,
  );

  return {
    connect: (instanceId: string) => {
      let { duplexerData } = selectors.getDuplexerData();

      if (duplexerData) {
        throw new Error('A11yWizardDuplexerAPI: Duplexer already connected');
      }

      const duplexer = new Duplexer(DUPLEXER_URL, {
        instanceUpdater: {
          getInstance: () => instanceId,
        },
      });
      const socket = duplexer.connect({
        appDefId: ACCESSIBLITY_WIZARD_APP_DEF_ID,
      });
      duplexerData = {
        duplexer,
        socket,
      };
      store.dispatch(a11yWizardDuplexerActions.setDuplexerData(duplexerData));

      return { duplexer, socket };
    },

    disconnect: () => {
      const { duplexerData } = selectors.getDuplexerData();

      if (!duplexerData) {
        return;
      }

      duplexerData.duplexer.close();
      duplexerData.socket.disconnect();
      store.dispatch(a11yWizardDuplexerActions.setDuplexerData(undefined));
    },

    getDuplexerData: () => selectors.getDuplexerData().duplexerData,
  };
};
